import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {Helper} from '../../utils/helper.module';
import { WINDOW, LOCAL_STORAGE } from '@ng-toolkit/universal';
import {Form} from "@angular/forms";
import {Question} from "./create-inscription-form/question";
import {HttpClient} from "@angular/common/http";
import { saveAs } from 'file-saver'
@Injectable()
export class EventsService {

  constructor(@Inject(WINDOW) private window:Window,
    @Inject(LOCAL_STORAGE) private localStorage: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient) {

  }



  dorefund(id): Promise<any> {
    return this.http.get(Helper.api('dorefund/'+id))
      .toPromise()
      .then((response) => {
       // console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  refundOrder(id): Promise<any> {
    return this.http.get(Helper.api('createOrderrefund/'+id))
      .toPromise()
      .then((response) => {
      //  console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  refundList(): Promise<any> {
    return this.http.get(Helper.api('refundList'))
      .toPromise()
      .then((response) => {
       // console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  refund(id): Promise<any> {
    return this.http.get(Helper.api('createrefund/'+id))
      .toPromise()
      .then((response) => {
       // console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  addEventPlan(event): Promise<any> {
    return this.http.post(Helper.api('addPlan'), event)
      .toPromise()
      .then((response) => {
      //  console.log(Promise.resolve(response));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  addEventVideo(event): Promise<any> {
    return this.http.post(Helper.api('addVideo'), event)
      .toPromise()
      .then((response) => {
      //  console.log(Promise.resolve(response));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  addEventImage(event): Promise<any> {
    return this.http.post(Helper.api('addMediaImage'), event)
      .toPromise()
      .then((response) => {
       // console.log(Promise.resolve(response));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  downloadRecap(id): Promise<any> { //modifier
    return this.http.get(Helper.api('recap_Vente/'+id))
      .toPromise()
      .then((response) => {
     //   console.log(Promise.resolve(response));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  downloadParticipantsList(id): Promise<any> { //modifier
    return this.http.get(Helper.api('participant_list/'+id))
      .toPromise()
      .then((response) => {
      //  console.log(Promise.resolve(response));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  organisation(id): Promise<any> {
    return this.http.get(Helper.api('organisations/'+id))
      .toPromise()
      .then((response) => {
        //console.log(response.json());
        // console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  organisationData(orgaId): Promise<any> {
    return this.http.get(Helper.api('organizationalldata/'+orgaId))
      .toPromise()
      .then((response) => {
        //console.log(response.json());
        // console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  userWithData(userId): Promise<any> {
    return this.http.get(Helper.api('user_and_datas/'+userId))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  events(): Promise<any> { //modifier
    return this.http.get(Helper.api('userevents'))
      .toPromise()
      .then((response) => {
       // console.log(response.json());
       // console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  userEventsForMultiList(): Promise<any> { //modifier
    return this.http.get(Helper.api('userEventsForMultiList'))
      .toPromise()
      .then((response) => {
       // console.log(response.json());
       // console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }



  managerevents(): Promise<any> { //modifier
    return this.http.get(Helper.api('managerevents'))
      .toPromise()
      .then((response) => {
     //   console.log(response.json());
      //  console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  userPaidEvents(): Promise<any> { //modifier
    return this.http.get(Helper.api('usereventsPayed'))
      .toPromise()
      .then((response) => {
      //  console.log(response.json());
      //  console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  managerList(): Promise<any> {
    return this.http.get(Helper.api('managerList'))
      .toPromise()
      .then((response) => {
       // console.log(response.json());
       // console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  orgaList(): Promise<any> {
    return this.http.get(Helper.api('orgaList'))
      .toPromise()
      .then((response) => {
       /* console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  alleventsForMultiList(): Promise<any> { //modifier
    return this.http.get(Helper.api('eventsForMultiList'))
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  allevents(): Promise<any> { //modifier
    return this.http.get(Helper.api('events'))
      .toPromise()
      .then((response) => {
       /* console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  payments(): Promise<any> { //modifier
    return this.http.get(Helper.api('userpayments'))
      .toPromise()
      .then((response) => {
       /* console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  duplicateEvent(event: any): Promise<any> {

    return this.http.post(Helper.api('duplicate'), event)
      .toPromise()
      .then((response) => {
        /*console.log(response.json());*/
        return Promise.resolve(response);
      })
      .catch(

      );
  }


  tickets(id): Promise<any> {
    return this.http.get(Helper.api('tickets/'+id))
      .toPromise()
      .then((response) => {
   /*     console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  pricings(id): Promise<any> {
    return this.http.get(Helper.api('pricings/'+id))
      .toPromise()
      .then((response) => {
     /*   console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  orders(id): Promise<any> {
    return this.http.get(Helper.api('orders/'+id))
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  allEventOrders(): Promise<any> {
    return this.http.get(Helper.api('allorders/'))
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  renvoyer(id): Promise<any> {
    return this.http.get(Helper.api('renvoyerticket/'+id))
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  annuler(id): Promise<any> {
    return this.http.get(Helper.api('annulerticket/'+id))
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }



//http://akces-api.devidia.net/api/events/

  save(event: any): Promise<any> {
    console.log(event);
    return this.http.post(Helper.api('events'), event) // use authHttp
      .toPromise()
      .then((response) => {
        /*console.log(response.json());*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  contactSend(contact: any): Promise<any> {

    return this.http.post(Helper.api('sendContact'), contact)
      .toPromise()
      .then((response) => {
       /* console.log(response.json());*/
        return Promise.resolve(response);
      })
      .catch(

      );
  }

  event(id): Promise<any> {//modifier
    return this.http.get(Helper.api('events/'+id))
      .toPromise()
      .then((response) => {
       /* console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  publier(id:any,event:Event): Promise<any> {
    return this.http.put(Helper.api('publier/'+id),event)
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  pricing(id): Promise<any> {
    return this.http.get(Helper.api('publier/'+id))
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }



  pays(): Promise<any> {
    return this.http.get('assets/plugins/countries.js')
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  categories(): Promise<any> {
    return this.http.get(Helper.api('categories'))
      .toPromise()
      .then((response) => {
        /*console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  update(id:any,event): Promise<any> {
    return this.http.put(Helper.api('update1/'+id),event)
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }



  invite(invitations): Promise<any> {
    return this.http.post(Helper.api('invit'),invitations)
      .toPromise()
      .then((response) => {
        /*  console.log(response.json());
         console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }
  downLoadFile(data: any, type: string) {
    let blob = new Blob([data], { type: type});
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert( 'Please disable your Pop-up blocker and try again.');
    }
  }

  downloadInvite(invitations): Promise<any> {
    return this.http.post(Helper.api('generate_and_download_invitation'),invitations)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  showpricing(id:any): Promise<any> {
    return this.http.get(Helper.api('showpricing/'+id),)
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  updatepricing(id:any,pricing): Promise<any> {
    return this.http.put(Helper.api('updatepricing/'+id),pricing)
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


    ticketDetail(id): Promise<any>
    {
      return this.http.get(Helper.api('ticket1detail/'+id))
        .toPromise()
        .then((response) => {
        /*  console.log(response.json());
          console.log(Promise.resolve(response.json()));*/
          return Promise.resolve(response);
        })
        .catch(Helper.handleError);
    }

  savepricing(pricing): Promise<any> {
    return this.http.post(Helper.api('savepricing/'),pricing)
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  deltepricing(id:any): Promise<any> {
    return this.http.delete(Helper.api('deletepricing/'+id),)
      .toPromise()
      .then((response) => {
        // console.log(response.json());
        // console.log(Promise.resolve(response.json()));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  pricingvisibility(id:any): Promise<any> {
    return this.http.get(Helper.api('pricingvisibility/'+id),)
      .toPromise()
      .then((response) => {
       /* console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  shownbPlace(id:any): Promise<any> {
    return this.http.get(Helper.api('shownbplace/'+id),)
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }



  eventpricings(id:any): Promise<any> {
    return this.http.get(Helper.api('eventpricings/'+id),)
      .toPromise()
      .then((response) => {
     /*   console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  eventaccreditations(id:any): Promise<any> {
    return this.http.get(Helper.api('eventaccreditations/'+id),)
      .toPromise()
      .then((response) => {
       /* console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  tvas(): Promise<any> {
    return this.http.get(Helper.api('tvas/'),)
      .toPromise()
      .then((response) => {
       /* console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  downloadPeopleCsv(json): Promise<any> {
    if (isPlatformBrowser(this.platformId) && !document) return Promise.resolve(false);
    return this.http.post(Helper.api('people/csv/'), {data:json})
      .toPromise()
      .then((response) => {
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.setAttribute('target', '_blank');
        a.href = "http://api.akces.fr/participants.csv";
        a.download = "participants.csv";
        a.click();
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  downloadResponsesCsv(json): Promise<any> {
    if (isPlatformBrowser(this.platformId) && !document) return Promise.resolve(false);
    return this.http.post(Helper.api('peopleresponses/csv/'), {data:json})
      .toPromise()
      .then((response) => {
        let a = document.createElement('a');
        window.location.href = 'https://api.akces.fr/participantsresponses.xlsx';
        /*document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.setAttribute('target', '_blank');
        a.href = "http://api.akces.fr/participantsresponses.xlsx";
        /!*a.download = "participantsResponses.xlsx";*!/
        a.click();*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

   dopayment(payment): Promise<any> {
    return this.http.post(Helper.api('payment/'),payment)
      .toPromise()
      .then((response) => {
       /* console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  cancelPayment(id): Promise<any> {
    return this.http.get(Helper.api('cancelPayment/'+id))
      .toPromise()
      .then((response) => {
       /* console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  savePricingGroup(pricingGroup): Promise<any> {
    return this.http.post(Helper.api('savepricingGroup/'),pricingGroup)
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  pricingGroupList(event_id): Promise<any> {
    return this.http.get(Helper.api('pricingGroups/'+event_id))
      .toPromise()
      .then((response) => {
       /* console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  deltepricingGroup(id:any): Promise<any> {
    return this.http.delete(Helper.api('deletepricingGroup/'+id),)
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  updatepricingGroup(id:any,pricingGroup): Promise<any> {
    return this.http.put(Helper.api('updatepricingGroup/'+id),pricingGroup)
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  downloadpdf(id): Promise<any> {
    return this.http.get(Helper.api('generatepdf/'+id),{responseType:"blob"})
      .toPromise()
      .then((response) => {
      /*  console.log(response);
        console.log(Promise.resolve(response.blob()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  geTicketName(id): Promise<any> {
    return this.http.get(Helper.api('getTicketName/'+id))
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  orderDetail(id): Promise<any> {
    return this.http.get(Helper.api('order/'+id))
      .toPromise()
      .then((response) => {
      /*  console.log(response.json());
        console.log(Promise.resolve(response.json()));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  listing_tarif(id)
  {
    return this.http.get(Helper.api('listing_by_tarifs/'+id))
      .toPromise()
      .then((response) => {
      /*  console.log(Promise.resolve(response));*/
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  listing_alphabetique(id)
  {
    return this.http.get(Helper.api('listing_participants/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  updateTicket(ticket)
  {
    return this.http.post(Helper.api('editTicket'), ticket)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  validateOrder(id): Promise<any> {
    return this.http.get(Helper.api('validateOrder/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  downloadOrder(id): Promise<any> {
    return this.http.get(Helper.api('downloadOrder/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  generateEventQrcode(event): Promise<any> {
    return this.http.post(Helper.api('eventQrcode'),event)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  shortEventUrl(event): Promise<any> {
    return this.http.post(Helper.api('getMainSmartUrl'),event)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  shortUrl(event): Promise<any> {
    return this.http.post(Helper.api('shortUrl'),event)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  eventSmartQrcode(event): Promise<any> {
    return this.http.post(Helper.api('eventQrcode'),event, {responseType: 'text'})
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  eventCustumSmart(event): Promise<any> {
    return this.http.post(Helper.api('saveCustumSmartUrl'),event)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  checkTicket(id): Promise<any> {
    return this.http.get(Helper.api('checkticket/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }



  questionList(): Promise<any> {
    return this.http.get(Helper.api('questions'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  saveForm(form): Promise<any> {
    return this.http.post(Helper.api('saveForm'),form)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  formList(): Promise<any> {
    return this.http.get(Helper.api('formList'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  getForm(id): Promise<any> {
    return this.http.get(Helper.api('showForm/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  updateForm(id:any,form:any): Promise<any> {
    return this.http.put(Helper.api('updateForm/'+id),form)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  deleteForm(id:any): Promise<any> {
    return this.http.delete(Helper.api('deleteform/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  userformList(): Promise<any> {
    return this.http.get(Helper.api('userForms'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  savePixels(user): Promise<any> {
    return this.http.post(Helper.api('savePixels'),user)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  deleEventWhenNoSale(id): Promise<any> {
    return this.http.get(Helper.api('deleteEventWhenNosale/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  archiveEvent(id): Promise<any> {
    return this.http.get(Helper.api('archiveEvent/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  closePricing(id): Promise<any> {
    return this.http.get(Helper.api('closePricing/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  unClosePricing(id): Promise<any> {
    return this.http.get(Helper.api('unClosePricing/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  askRibMail(orgaId): Promise<any> {
    return this.http.get(Helper.api('askRib/'+orgaId))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  saveQuestion(question:Question): Promise<any> {
    return this.http.post(Helper.api('saveCustomQuestion'),question)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  duplicatePricing(toDuplicate): Promise<any> {
    return this.http.post(Helper.api('duplicatepricing'),toDuplicate)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  saveCguConfig(event:any): Promise<any> {
    return this.http.post(Helper.api('savecguconfig'),event)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }



  saveBookingSessionTime(event:any): Promise<any> {
    return this.http.post(Helper.api('saveEventBookingEpirationTime'),event)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  savePaymentConfig(event:any): Promise<any> {
    return this.http.post(Helper.api('savepaymentconfig'),event)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  getCodePromos(event_id): Promise<any> {
    return this.http.get(Helper.api('eventcodepromos/'+event_id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  saveCodePromo(codePromo): Promise<any> {
    return this.http.post(Helper.api('saveCodepromo'),codePromo)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  updateCodePromo(codePromo): Promise<any> {
    return this.http.post(Helper.api('updateCodepromo'),codePromo)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  showCodePromo(code_id): Promise<any> {
    return this.http.get(Helper.api('showcodepromo/'+code_id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  deletecodePromo(code_id): Promise<any> {
    return this.http.get(Helper.api('deletecodepromo/'+code_id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  duplicatecodePromo(code): Promise<any> {
    return this.http.post(Helper.api('duplicatecodePromo'),code)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  activateOrDesactivateCodePromo(code:any): Promise<any> {
    return this.http.post(Helper.api('changecodepromostate'),code)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

 savePricingTicketCustomisation(pricingTicketCustomisation:any): Promise<any> {
    return this.http.post(Helper.api('savepricingCustomisation'),pricingTicketCustomisation)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  getIp(): Promise<any> {
    return this.http.post(Helper.api('getIp'),{})
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  getFile(path): Promise<any> {

    return this.http.post(Helper.api('getFile'),{'path':path})
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  eventIsncriptions(id:any): Promise<any> {
    return this.http.get(Helper.api('inscriptions/'+id),)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }



  ValidateIsncriptions(id:any): Promise<any> {
    return this.http.get(Helper.api('validateinscriptions/'+id),)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  RefuseIsncriptions(id:any): Promise<any> {
    return this.http.get(Helper.api('refuseinscriptions/'+id),)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  ReegistrationRequests(id:any): Promise<any> {
    return this.http.get(Helper.api('eventsubstractionrequests/'+id),)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  getReegistrationRequests(id:any): Promise<any> {
    return this.http.get(Helper.api('getsubstractionrequest/'+id),)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }




  deleteReegistrationRequests(id:any): Promise<any> {
    return this.http.get(Helper.api('deletesubstractionrequest/'+id),)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  SaveReegistrationRequest(any): Promise<any> {
    return this.http.post(Helper.api('createsubstractionrequest'),any)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  updateReegistrationRequest(any): Promise<any> {
    return this.http.post(Helper.api('updatesubstractionrequest'),any)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  getAkcesLinks($date): Promise<any> {
    return this.http.get(Helper.api('akceslinks/'+$date))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  saveAkcesLinks(any): Promise<any> {
    return this.http.post(Helper.api('savelinks'),any)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  eventInProgress(any): Promise<any> {
    return this.http.get(Helper.api('eventInProgress/'+any))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  /*incopletInscriptions(id:any): Promise<any> {
    return this.authHttp.get(Helper.api('validateinscriptions/'+id),)
      .toPromise()
      .then((response) => {
        console.log(response.json());
        console.log(Promise.resolve(response.json()));
        return Promise.resolve(response.json());
      })
      .catch(Helper.handleError);
  }*/

  loadDashboarddata(date): Promise<any> {
    return this.http.get(Helper.api('dashboarddata/'+date))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  payment(): Promise<any> {
    return this.http.get(Helper.api('payments/'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  loadUsereventsandtickets() {
    return this.http.get(Helper.api('usereventsandtickets'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  interestSuggestion(category_id): Promise<any> {
    return this.http.get(Helper.api('category_tags/'+category_id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  loadAllTags(): Promise<any> {
    return this.http.get(Helper.api('tags'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

}
